<template>
  <div class="date-input input">
    <toggle-box ref="inputBox" class="date-input-box">
      <template v-slot:control>
        <text-input
          v-model="wrappedValue"
          :label="label"
          icon-position="right"
          :required="required"
          :borderbottom="borderbottom"
          :validate="validateDate"
          :disabled="disabled"
          @focus="showInputBox()"
          ref="input"
        >
          <template v-slot:icon>
            <font-awesome-icon
              @click="showInputBox()"
              class="icon"
              :class="{ disabled }"
              :icon="faCalendarAlt"
            />
          </template>
        </text-input>
      </template>
      <template v-slot:content>
        <calendar
          :date="moment(wrappedValue, DISPLAY_DATE_FORMAT).toISOString() || undefined"
          @dateChange="setValue"
          :yearRange="yearRange"
        />
      </template>
    </toggle-box>
  </div>
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';

import TextInput from '@/components/TextInput';
import ToggleBox from '@/components/ToggleBox';
import Calendar from '@/components/Calendar';

import { DATE_FORMAT, DISPLAY_DATE_FORMAT, MIN_DATE } from '@/consts';

export default {
  name: 'DateInput',
  components: {
    TextInput,
    ToggleBox,
    Calendar,
    FontAwesomeIcon
  },
  props: {
    value: {
      type: String,
      default: moment().format(DISPLAY_DATE_FORMAT)
    },
    label: {
      type: String,
      default: ''
    },
    validate: {
      type: Function,
      default: () => ''
    },
    yearRange: {
      type: Array,
      default: () => [moment(MIN_DATE).year(), moment().year() + 1]
    },
    required: {
      type: Boolean,
      default: false
    },
    borderbottom: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const inputBox = ref(null);
    const input = ref(null);

    const isValid = computed(() => input.value.isValid);

    const wrappedValue = computed({
      get() { return props.value; },
      set(val) {
        emit('input', val);
      }
    });

    const showInputBox = () => {
      if (props.disabled) return;
      inputBox.value.toggle(true);
    };

    const setValue = (val) => {
      wrappedValue.value = moment(val, DATE_FORMAT).format(DISPLAY_DATE_FORMAT);
      inputBox.value.toggle(false);
    };

    const validateDate = (val) => {
      const date = moment(val, DISPLAY_DATE_FORMAT, true);

      if (!date.isValid()) {
        return 'INVALID_DATE_FORMAT';
      }

      return props.validate(val);
    };

    const validateInput = () => input.value.validateInput();

    return {
      inputBox,
      input,
      showInputBox,
      setValue,
      faCalendarAlt,
      wrappedValue,
      validateDate,
      moment,
      DISPLAY_DATE_FORMAT,
      isValid,
      validateInput
    };
  }
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/colors';

.date-input {
  .date-input-box {
    svg {
      cursor: pointer;
      transition: all .2s ease-in-out;

      &:hover {
        color: $paradisePink;
      }

      &.disabled {
        pointer-events: none;
      }
    }

    .toggle-box-wrapper {
      top: 44px;
    }
  }
}
</style>
